<div
  class="input-check"
  [class.input-check--show]="showMode()"
>
  <procure-checkbox
    matTooltipClass="line-breaks-tooltip"
    [control]="control()"
    [labelPosition]="labelPosition()"
    [disabled]="showMode() || control().disabled"
    [matTooltip]="tooltip()"
    [showMode]="showMode()"
    [checked]="control().value"
    [condensed]="condensed()"
    [indeterminate]="control().value === null"
    (valueChange)="valueChange.emit($event)"
  >
    <ng-content />
  </procure-checkbox>
</div>
